import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a phone number from environment variable format (e.g., "7346790679") 
 * to display format (e.g., "(734) 679-0679")
 * @param phoneNumber - The phone number in raw format
 * @returns Formatted phone number string
 */
export function formatPhoneNumber(phoneNumber: string): string {
  // Remove any non-digit characters
  const cleaned = phoneNumber.replace(/\D/g, '')
  
  // Check if it's a valid 10-digit US phone number
  if (cleaned.length === 10) {
    const areaCode = cleaned.slice(0, 3)
    const prefix = cleaned.slice(3, 6)
    const lineNumber = cleaned.slice(6, 10)
    return `(${areaCode}) ${prefix}-${lineNumber}`
  }
  
  // If not 10 digits, return as is
  return phoneNumber
}

/**
 * Get the formatted phone number from environment variable
 * @returns Formatted phone number string
 */
export function getFormattedPhone(): string {
  const phone = process.env.NEXT_PUBLIC_PHONE
  if (!phone) {
    console.warn('NEXT_PUBLIC_PHONE environment variable is not set')
    return '(734) 679-0679' // Fallback
  }
  return formatPhoneNumber(phone)
}

/**
 * Get the email from environment variable
 * @returns Email string
 */
export function getEmail(): string {
  const email = process.env.NEXT_PUBLIC_EMAIL
  if (!email) {
    console.warn('NEXT_PUBLIC_EMAIL environment variable is not set')
    return 'hello@toribportraits.com' // Fallback
  }
  return email
}
